<div class="admin-columns">
	<div class="admin-column tree">
		@if (treenodes === undefined) {
		<div class="loading-status">
			<div class="logo-spin"></div>
			Loading...
		</div>
		}
		@if (treenodes) {
		<div class="asset-tree scrollable">
			@for (org of treenodes; track org) {
			<div class="org-wrapper">
				<div class="org-row expandable" [attr.data-orgid]="org.organization_id">
					<a (click)="ClickExpander($event)" class="expander-icon" [class.expanded]="org.expanded" [class.blank]="!(org.configs && org.configs.length > 0)"></a>
					<a class="org-link" (click)="ClickOrg($event)">{{org.name}}</a>
				</div>
				@for (config of org.configs; track config) {
				<div class="expandable-children">
					<a href="javascript:void(0)" (click)="ClickConfig($event, config)" class="fleet-link" [class.selected]="selectedItem === config">{{config.asset_type_name}}</a>
				</div>
				}
			</div>
			}
		</div>
		}
	</div>
	<div class="admin-column main">
		@if (selectedItem) {
		<div>
			<div class="section-title">{{selectedItem.asset_type_name}}</div>
			<div class="mb-3 row">
				<label class="col-md-4">Engine:</label>
				<div class="col-md-8">{{selectedItem.engine}}</div>
			</div>
			<div class="mb-3 row">
				<label class="col-md-4">Gearbox:</label>
				<div class="col-md-8">{{selectedItem.gearbox}}</div>
			</div>
			<div class="mb-3 row">
				<label class="col-md-4">Version:</label>
				<div class="col-md-8">{{selectedVersion}}</div>
			</div>
			<div class="mb-3 row">
				<label class="col-md-4">Assets using this configuration:</label>
				<div class="col-md-8">
					@for (asset of selectedItem.assets; track asset) {
					<div>{{asset.asset_name}} ({{asset.obcu_serial_number}})</div>
					}
				</div>
			</div>
			@if (!selectedItem.assets.length) {
			<app-action-button [action]="DeleteConfig" [context]="this" processing="Deleting..." complete="Config deleted" confirm="Are you sure?" btnClass="red">Delete
				Config</app-action-button>
			}
			@if (selectedItem.assets.length) {
			<button disabled class="button red">Can't delete - existing assets</button>
			}
		</div>
		}
	</div>
</div>

@if (selectedItem) {
<div class="row">
	<div class="col-lg-6">
		<div class="panel constrain">
			<div class="heading fat">Current config XML <button (click)="DuplicateConfig()" class="button small compact ms-5">Duplicate</button></div>
			<div class="content nopad">
				<div>
					<textarea [(ngModel)]="oldConfig" class="form-control flush" style="min-height: 400px;" readonly></textarea>
				</div>
			</div>
		</div>
	</div>
	<div class="col-lg-6">
		<div class="panel constrain">
			<div class="heading fat">New config XML</div>
			<div class="content nopad">
				<div>
					<textarea [(ngModel)]="newConfig" class="form-control flush" style="min-height: 400px;"></textarea>
				</div>
			</div>
		</div>
		<app-action-button [action]="UpdateConfig" [context]="this" processing="Updating..." complete="Config updated" btnClass="green">Update Config</app-action-button>
	</div>
</div>
}